import { TicketActionType } from "./ticket.enums";

export class DeliveryParameters {
    TicketAction: TicketActionType;
    EmailAddress: string;
    Title: string;
    FirstName: string;
    Surname: string;
    MemberId: string;
    CharityId: number;
  }